import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

interface FeedbackDialogProps {
  open: boolean;
  comment: string;
  isSubmitting?: boolean;
  onCommentChange: (value: string) => void;
  onSubmit: () => void;
  onSkip: () => void;
  onOpenChange: (open: boolean) => void;
}

export function FeedbackDialog({
  open,
  comment,
  isSubmitting = false,
  onCommentChange,
  onSubmit,
  onSkip,
  onOpenChange,
}: FeedbackDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Help us improve</DialogTitle>
          <DialogDescription>Optional: tell us what went wrong.</DialogDescription>
        </DialogHeader>
        <Textarea
          value={comment}
          onChange={(event) => onCommentChange(event.target.value)}
          placeholder="Add a comment (optional)"
          rows={4}
        />
        <div className="mt-4 flex justify-end gap-2">
          <Button variant="outline" onClick={onSkip} disabled={isSubmitting}>
            Skip
          </Button>
          <Button onClick={onSubmit} disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

FeedbackDialog.displayName = "FeedbackDialog";
